import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import debounce from 'lodash.debounce';
import TextareaAutosize from 'react-autosize-textarea';
import ModalTrigger from '../../common/ModalTrigger';
import NotInvoicingModal from '../../NotInvoicingModal';
import ProjectNameSummaryModal from '../../ProjectNameSummaryModal';
import { putRequest, postRequest } from '../../../requestUtils';
import { formatCurrency, formatCurrencyPlain } from '../../../numberUtils';
import InfoTooltip from '../../common/InfoTooltip';
import ActionDropdown from '../../common/ActionDropdown/ActionDropdown';
import dollarSign from '../../../../assets/images/icons/dollar-sign.png';
import chevronDown from '../../../../assets/images/icons/chevronDownWhite.svg';
import './InvoiceHeader.scss';
var dateDiffInDays = function dateDiffInDays(a, b) {
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.ceil((utc2 - utc1) / (1000 * 60 * 60 * 24));
};
var numericKeyFilter = function numericKeyFilter(e) {
  var re = /[0-9]/;
  var allowed = [8, 46, 37, 38, 39, 40];
  if (allowed.includes(e.keyCode)) {
    return;
  }
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};
var InvoiceHeader = /*#__PURE__*/function (_Component) {
  function InvoiceHeader(props) {
    var _this;
    _classCallCheck(this, InvoiceHeader);
    _this = _callSuper(this, InvoiceHeader, [props]);
    _this.state = {
      status: props.status,
      statusDisplay: props.statusDisplay,
      memo: props.memo || '',
      projectedHours: props.projectedHours,
      submissionRequested: false,
      requestSubmissionMessage: '',
      isReadingMore: false,
      showReadMore: false,
      showErrorMsg: false,
      consultantPayoutOverride: formatCurrencyPlain(props.consultantPayoutOverride),
      grossRevenueOverride: formatCurrencyPlain(props.grossRevenueOverride),
      overrideReason: props.overrideReason,
      overrideSubmitted: props.consultantPayoutOverride || props.grossRevenueOverride,
      overrideErrors: [],
      showAmountOverrideModal: false,
      forceShowModalKey: 0
    };
    _this.readMore = _this.readMore.bind(_this);
    _this.errorMsg = _this.errorMsg.bind(_this);
    _this.updateMemo = _this.updateMemo.bind(_this);
    _this.handleUpdateMemo = debounce(_this.handleUpdateMemo.bind(_this), 300);
    _this.handleRevertToDraft = _this.handleRevertToDraft.bind(_this);
    _this.updateProjectedHours = _this.updateProjectedHours.bind(_this);
    _this.handleSubmitOverrides = _this.handleSubmitOverrides.bind(_this);
    _this.handleUpdateProjectedHours = debounce(_this.handleUpdateProjectedHours.bind(_this));
    _this.updateRequestSubmissionMessage = _this.updateRequestSubmissionMessage.bind(_this);
    _this.handleRequestSubmissionSubmit = _this.handleRequestSubmissionSubmit.bind(_this);
    _this.renderRequestSubmission = _this.renderRequestSubmission.bind(_this);
    _this.renderSubmitTimeSheet = _this.renderSubmitTimeSheet.bind(_this);
    _this.toggleAmountOverrideModal = _this.toggleAmountOverrideModal.bind(_this);
    return _this;
  }
  _inherits(InvoiceHeader, _Component);
  return _createClass(InvoiceHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setShowReadMore();
    }
  }, {
    key: "setShowReadMore",
    value: function setShowReadMore() {
      // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
      // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
      this.setState({
        showReadMore: this.memoElement && this.memoElement.scrollHeight > this.memoElement.clientHeight + 1
      });
    }
  }, {
    key: "readMore",
    value: function readMore() {
      this.setState({
        isReadingMore: !this.state.isReadingMore
      });
    }
  }, {
    key: "errorMsg",
    value: function errorMsg(value) {
      this.setState({
        showErrorMsg: value
      });
    }
  }, {
    key: "updateMemo",
    value: function updateMemo(value) {
      this.setState({
        memo: value
      });
      this.handleUpdateMemo();
    }
  }, {
    key: "handleUpdateMemo",
    value: function handleUpdateMemo() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        id = _this$props.id;
      var memo = this.state.memo;
      putRequest("/invoices/".concat(id), {
        invoice: {
          memo: memo
        }
      }, csrfToken);
    }
  }, {
    key: "handleRevertToDraft",
    value: function handleRevertToDraft() {
      var _this2 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        id = _this$props2.id;
      putRequest("/invoices/".concat(id, "/draft"), {}, csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this2.setState({
          statusDisplay: data.status_display,
          status: data.status
        });
      });
    }
  }, {
    key: "updateProjectedHours",
    value: function updateProjectedHours(value) {
      this.errorMsg(false);
      this.setState({
        projectedHours: value
      });
      this.handleUpdateProjectedHours();
    }
  }, {
    key: "handleUpdateProjectedHours",
    value: function handleUpdateProjectedHours() {
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        id = _this$props3.id;
      var projectedHours = this.state.projectedHours;
      putRequest("/invoices/".concat(id), {
        projected_hours_by_consultants: projectedHours
      }, csrfToken);
    }
  }, {
    key: "updateRequestSubmissionMessage",
    value: function updateRequestSubmissionMessage(value) {
      this.setState({
        requestSubmissionMessage: value
      });
    }
  }, {
    key: "handleRequestSubmissionSubmit",
    value: function handleRequestSubmissionSubmit() {
      var _this3 = this;
      var _this$props4 = this.props,
        id = _this$props4.id,
        csrfToken = _this$props4.csrfToken;
      var requestSubmissionMessage = this.state.requestSubmissionMessage;
      return postRequest("/invoices/".concat(id, "/remind_to_submit"), {
        message: requestSubmissionMessage
      }, csrfToken).then(function () {
        _this3.setState({
          submissionRequested: true
        });
      });
    }
  }, {
    key: "handleSubmitOverrides",
    value: function handleSubmitOverrides() {
      var _this4 = this;
      var _this$props5 = this.props,
        id = _this$props5.id,
        csrfToken = _this$props5.csrfToken;
      var _this$state = this.state,
        grossRevenueOverride = _this$state.grossRevenueOverride,
        consultantPayoutOverride = _this$state.consultantPayoutOverride,
        overrideReason = _this$state.overrideReason,
        forceShowModalKey = _this$state.forceShowModalKey;
      postRequest("/invoices/".concat(id, "/add_override"), {
        invoice_override: {
          gross_revenue: grossRevenueOverride ? grossRevenueOverride.replace(/,/, '') * 100 : null,
          consultant_payout: consultantPayoutOverride ? consultantPayoutOverride.replace(/,/, '') * 100 : null,
          reason_for_change: overrideReason
        }
      }, csrfToken).then(function () {
        _this4.setState({
          forceShowModalKey: forceShowModalKey + 1,
          showAmountOverrideModal: false,
          overrideSuccess: true,
          overrideErrors: [],
          overrideSubmitted: true
        });
      })["catch"](function (err) {
        _this4.setState({
          overrideSuccess: false,
          overrideErrors: err.errors
        });
      });
    }
  }, {
    key: "overridesValid",
    value: function overridesValid() {
      var _this$state2 = this.state,
        grossRevenueOverride = _this$state2.grossRevenueOverride,
        consultantPayoutOverride = _this$state2.consultantPayoutOverride,
        overrideReason = _this$state2.overrideReason;
      return overrideReason && (grossRevenueOverride || consultantPayoutOverride);
    }
  }, {
    key: "toggleAmountOverrideModal",
    value: function toggleAmountOverrideModal() {
      var forceShowModalKey = this.state.forceShowModalKey;
      this.setState({
        showAmountOverrideModal: true,
        forceShowModalKey: forceShowModalKey + 1
      });
    }
  }, {
    key: "renderInvoiceState",
    value: function renderInvoiceState() {
      var _this$props6 = this.props,
        statusDisplay = _this$props6.statusDisplay,
        statusChangeDate = _this$props6.statusChangeDate,
        editsRequestedBy = _this$props6.editsRequestedBy,
        editsRequestedOn = _this$props6.editsRequestedOn,
        approvedBy = _this$props6.approvedBy,
        approvedOn = _this$props6.approvedOn;
      var status = this.state.status;
      if (status === 'draft') {
        return this.renderDaysLeftToSubmit('timesheet');
      }
      if (status === 'edits_requested' && editsRequestedBy && editsRequestedOn) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "Edits requested by", ' ', editsRequestedBy, ' ', "on", ' ', moment(editsRequestedOn).format('LL')), this.renderDaysLeftToSubmit('changes'));
      }
      if (status === 'approved_by_rep' && approvedBy && approvedOn) {
        return "Approved by ".concat(approvedBy, " - ").concat(moment(approvedOn).format('LL'));
      }
      return "".concat(statusDisplay, " on ").concat(statusChangeDate);
    }
  }, {
    key: "renderDaysLeftToSubmit",
    value: function renderDaysLeftToSubmit(item) {
      var consultantDueDate = this.props.consultantDueDate;
      var daysLate = dateDiffInDays(new Date(consultantDueDate.replace(/-/g, '/')), new Date());
      if (daysLate > 0) {
        return /*#__PURE__*/React.createElement("span", {
          className: "late-warning"
        }, /*#__PURE__*/React.createElement("i", {
          className: "far fa-clock me-2"
        }), daysLate, ' ', "day", Math.abs(daysLate) > 1 ? 's' : '', ' ', "late. Please submit your", item, ' ', "ASAP!");
      }
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "far fa-clock me-2"
      }), /*#__PURE__*/React.createElement("strong", null, daysLate * -1, ' ', "day", Math.abs(daysLate) > 1 ? 's' : '', ' ', "left"), ' ', "to submit", item);
    }
  }, {
    key: "renderAmountOverrideWarning",
    value: function renderAmountOverrideWarning() {
      var _this$props7 = this.props,
        isRep = _this$props7.isRep,
        overrideDate = _this$props7.overrideDate;
      var _this$state3 = this.state,
        consultantPayoutOverride = _this$state3.consultantPayoutOverride,
        grossRevenueOverride = _this$state3.grossRevenueOverride,
        overrideSubmitted = _this$state3.overrideSubmitted;
      if (!isRep || !overrideSubmitted || !(consultantPayoutOverride || grossRevenueOverride)) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "mt-2 body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "invoice-override-warning"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle mr-8"
      }), "Overrides added on", ' ', overrideDate, ".", ' ', "Total invoice value no longer matches the actual invoice.", ' ', /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        className: "override-details-link",
        onClick: this.toggleAmountOverrideModal
      }, "See details")));
    }
  }, {
    key: "renderHourLimitWarning",
    value: function renderHourLimitWarning() {
      var _this$props8 = this.props,
        showHourWarning = _this$props8.showHourWarning,
        hourLimit = _this$props8.hourLimit,
        totalHours = _this$props8.totalHours,
        totalMinutes = _this$props8.totalMinutes;
      var addedTotalHours = totalHours;
      if (totalMinutes >= 60) {
        addedTotalHours += parseInt(totalMinutes / 60, 10);
      }
      if (showHourWarning && addedTotalHours > hourLimit) {
        return /*#__PURE__*/React.createElement("div", {
          className: "hour-limit-warning"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-exclamation-triangle mr-8"
        }), "You are above your", ' ', hourLimit, ' ', "hour limit this month but you may still submit your timesheet.");
      }
      return false;
    }
  }, {
    key: "renderSubmittedText",
    value: function renderSubmittedText() {
      var employerApprovalDueDate = this.props.employerApprovalDueDate;
      var today = new Date();
      if (today > new Date(employerApprovalDueDate)) {
        return 'Approval window about to expire. Approve now.';
      }
      var formattedDueDate = moment(employerApprovalDueDate).format('MMMM D');
      return "Approve this timesheet by ".concat(formattedDueDate);
    }
  }, {
    key: "renderDueDate",
    value: function renderDueDate() {
      var _this$props9 = this.props,
        isProjectTeamMember = _this$props9.isProjectTeamMember,
        isRep = _this$props9.isRep,
        updatedAt = _this$props9.updatedAt,
        employerApprovalDueDate = _this$props9.employerApprovalDueDate;
      var status = this.state.status;
      if (isProjectTeamMember && status === 'submitted') {
        return /*#__PURE__*/React.createElement("span", {
          className: "submitted-display-alert body-text-2 normal-weight"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-exclamation-triangle me-2"
        }), this.renderSubmittedText());
      }
      if (isRep && status === 'submitted') {
        return /*#__PURE__*/React.createElement("span", {
          className: "submitted-display body-text-2 normal-weight"
        }, "Submitted", ' ', moment(updatedAt).format('YYYY-MM-DD'), ". Employer must approve by", ' ', employerApprovalDueDate);
      }
      return null;
    }
  }, {
    key: "renderRequestSubmission",
    value: function renderRequestSubmission() {
      var _this5 = this;
      var triggerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var consultantName = this.props.consultantName;
      var requestSubmissionMessage = this.state.requestSubmissionMessage;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Request Submission",
        triggerType: triggerType,
        buttonStyles: "".concat(triggerType === 'button' && 'primary ', " primary-link"),
        submitButtonText: "Yes, Request Submission",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleRequestSubmissionSubmit,
        submitDisabled: !requestSubmissionMessage,
        idKey: "request-submission-invoice",
        closeAfterSubmit: true,
        modalSize: "lg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "request-submission-invoice-modal style-guide p-3"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Requesting Submission"), /*#__PURE__*/React.createElement(TextareaAutosize, {
        id: "request-submission-message",
        name: "request-submission-message",
        value: requestSubmissionMessage,
        className: "request-submission-message",
        placeholder: "Add a message for the consultant here",
        rows: 4,
        onChange: function onChange(e) {
          return _this5.updateRequestSubmissionMessage(e.target.value);
        }
      }), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-3"
      }, "Required. This message will be sent directly to", ' ', consultantName, "\xA0to provide context around this request.")));
    }
  }, {
    key: "renderSubmitTimeSheet",
    value: function renderSubmitTimeSheet() {
      var triggerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'button';
      var _this$props10 = this.props,
        id = _this$props10.id,
        month = _this$props10.month,
        year = _this$props10.year,
        company = _this$props10.company;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Submit Timesheet",
        triggerType: triggerType,
        cancelButtonText: "No, Don't submit yet",
        idKey: "submit-invoice",
        buttonStyles: "primary",
        submitButtonNode: /*#__PURE__*/React.createElement("a", {
          href: "/invoices/".concat(id, "/submit_to_clora"),
          "data-turbo-method": "put",
          id: "submit-invoice",
          className: "btn btn-primary",
          role: "button"
        }, "Yes, Submit to employer"),
        closeAfterSubmit: true,
        modalSize: "lg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "approve-invoice-modal style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Do you want to submit your", ' ', month, ' ', year, ' ', "timesheet to", ' ', company, "?"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-3"
      }, "You cannot modify your timesheet after submitting it to the employer.")));
    }
  }, {
    key: "renderRetractButton",
    value: function renderRetractButton() {
      var id = this.props.id;
      return /*#__PURE__*/React.createElement("a", {
        href: "/invoices/".concat(id, "/edit"),
        className: "invoice-request-edit-redirect",
        id: "retract-and-edit-button",
        tabIndex: 0
      }, "Retract and Request Edits");
    }
  }, {
    key: "renderOverridesModal",
    value: function renderOverridesModal() {
      var _this6 = this;
      var _this$props11 = this.props,
        isRep = _this$props11.isRep,
        company = _this$props11.company,
        month = _this$props11.month,
        year = _this$props11.year,
        consultantName = _this$props11.consultantName,
        projectName = _this$props11.projectName,
        totals = _this$props11.totals;
      var _this$state4 = this.state,
        grossRevenueOverride = _this$state4.grossRevenueOverride,
        consultantPayoutOverride = _this$state4.consultantPayoutOverride,
        overrideReason = _this$state4.overrideReason,
        overrideErrors = _this$state4.overrideErrors,
        overrideSuccess = _this$state4.overrideSuccess,
        showAmountOverrideModal = _this$state4.showAmountOverrideModal,
        forceShowModalKey = _this$state4.forceShowModalKey;
      if (!isRep) return null;
      var total = totals.totalWithoutExpenses.replace('$', '');
      var adjustedTotal = totals.adjustedTotalWithoutExpenses.replace('$', '');
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Add Overrides",
        cancelButtonText: "Cancel",
        idKey: "add-overrides",
        buttonStyles: "add-overrides-button",
        showModal: showAmountOverrideModal,
        key: forceShowModalKey,
        submitButtonNode: /*#__PURE__*/React.createElement("a", {
          role: "button",
          tabIndex: 0,
          disabled: !this.overridesValid(),
          onClick: this.overridesValid() ? this.handleSubmitOverrides : function () {},
          id: "add-invoice-override-confirm",
          className: "btn btn-primary"
        }, "Save")
      }, /*#__PURE__*/React.createElement("h1", null, "Add Overrides"), /*#__PURE__*/React.createElement("div", {
        className: "success-text"
      }, overrideSuccess ? 'Override submitted.' : ''), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Overrides will be used as the final gross revenue in various finance and investor reports.", ' ', "Only add overrides when you\u2019re certain that Timesheet gross amount is inaccurate for the", ' ', "selected month."), /*#__PURE__*/React.createElement("div", {
        className: "add-invoice-override-info mt-3"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "override-info-item"
      }, /*#__PURE__*/React.createElement("li", null, "Client:", /*#__PURE__*/React.createElement("strong", {
        className: "ps-2"
      }, company)), /*#__PURE__*/React.createElement("li", null, "Project:", /*#__PURE__*/React.createElement("strong", {
        className: "ps-2"
      }, projectName)), /*#__PURE__*/React.createElement("li", null, "Consultant Name:", /*#__PURE__*/React.createElement("strong", {
        className: "ps-2"
      }, consultantName)), /*#__PURE__*/React.createElement("li", null, "Timesheet Month:", /*#__PURE__*/React.createElement("strong", {
        className: "ps-2"
      }, month, ' ', year)))), /*#__PURE__*/React.createElement("div", {
        className: "revenue-override mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row revenue-section  mb-3 "
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5 original-gross-revenue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "revenue-override-heading"
      }, "Gross Revenue per Timesheet (excluding Expenses)"), /*#__PURE__*/React.createElement("div", {
        className: "original-revenue"
      }, /*#__PURE__*/React.createElement("img", {
        className: "dollar-sign pe-3",
        src: dollarSign,
        alt: "dollar sign"
      }), /*#__PURE__*/React.createElement("span", {
        className: "amount"
      }, adjustedTotal))), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-2 arrow"
      }, "\u2B62"), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5 gross-revenue-override"
      }, /*#__PURE__*/React.createElement("div", {
        className: "revenue-override-heading"
      }, "Actual Gross Revenue ($ billed to client excluding Expenses)"), /*#__PURE__*/React.createElement("div", {
        className: "revenue-override row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-2"
      }, /*#__PURE__*/React.createElement("img", {
        className: "dollar-sign pe-3",
        src: dollarSign,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-10 ps-0"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "override",
        name: "gross_revenue_override",
        value: grossRevenueOverride,
        onChange: function onChange(e) {
          return _this6.setState({
            grossRevenueOverride: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          return _this6.setState({
            grossRevenueOverride: formatCurrencyPlain(e.target.value)
          });
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "row revenue-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5 original-net-revenue"
      }, /*#__PURE__*/React.createElement("div", {
        className: "revenue-override-heading"
      }, "Consultant Payout per Timesheet (excluding Expenses)"), /*#__PURE__*/React.createElement("div", {
        className: "original-revenue"
      }, /*#__PURE__*/React.createElement("img", {
        className: "dollar-sign pe-3",
        src: dollarSign,
        alt: "dollar sign"
      }), /*#__PURE__*/React.createElement("span", {
        className: "amount"
      }, total))), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-2 arrow"
      }, "\u2B62"), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5 net-revenue-override"
      }, /*#__PURE__*/React.createElement("div", {
        className: "revenue-override-heading"
      }, "Actual Consultant Payout (excluding Expenses)"), /*#__PURE__*/React.createElement("div", {
        className: "revenue-override row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-2 pe-3"
      }, /*#__PURE__*/React.createElement("img", {
        className: "dollar-sign",
        src: dollarSign,
        alt: "dollar sign"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-10 ps-0"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "override",
        name: "consultant_payout_override",
        value: consultantPayoutOverride,
        onChange: function onChange(e) {
          return _this6.setState({
            consultantPayoutOverride: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          return _this6.setState({
            consultantPayoutOverride: formatCurrencyPlain(e.target.value)
          });
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "revenue-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }, "Reason for change"), /*#__PURE__*/React.createElement("textarea", {
        name: "reason_for_change",
        onChange: function onChange(e) {
          _this6.setState({
            overrideReason: e.target.value
          });
        }
      }, overrideReason))), /*#__PURE__*/React.createElement("div", {
        className: "error-text"
      }, overrideErrors.map(function (err) {
        return /*#__PURE__*/React.createElement("li", null, err);
      })));
    }
  }, {
    key: "renderPushToQuickbooks",
    value: function renderPushToQuickbooks() {
      var _this$props12 = this.props,
        id = _this$props12.id,
        csrfToken = _this$props12.csrfToken,
        hasQuickbooksCustomerId = _this$props12.hasQuickbooksCustomerId,
        editCompanyUrl = _this$props12.editCompanyUrl,
        company = _this$props12.company;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Push to Quickbooks",
        cancelButtonText: "No, Don't Push to QBO",
        idKey: "push-invoice-to-quickbooks",
        buttonStyles: "primary a",
        modalSize: "md",
        submitButtonNode: /*#__PURE__*/React.createElement("form", {
          action: "/invoices/".concat(id, "/quickbooks"),
          method: "post",
          "data-turbo": "false"
        }, /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "authenticity_token",
          value: csrfToken
        }), /*#__PURE__*/React.createElement("button", {
          type: "submit",
          id: "push-invoice-to-quickbooks-confirm",
          className: "btn btn-primary"
        }, "Yes, Push to Quickbooks"))
      }, /*#__PURE__*/React.createElement("div", {
        className: "push-invoice-to-quickbooks-modal style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3 center"
      }, "Are you sure you want to push to quickbooks?")), !hasQuickbooksCustomerId && /*#__PURE__*/React.createElement("div", {
        className: "mb-3 warning"
      }, "Please update Quickbooks Customer ID on", ' ', /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: editCompanyUrl,
        rel: "noreferrer"
      }, company, "'s edit page"), ' ', "so that invoices can be created automatically."));
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this7 = this;
      var _this$props13 = this.props,
        isRep = _this$props13.isRep,
        isProjectTeamMember = _this$props13.isProjectTeamMember,
        isAdmin = _this$props13.isAdmin,
        id = _this$props13.id,
        consultantName = _this$props13.consultantName,
        month = _this$props13.month,
        year = _this$props13.year,
        company = _this$props13.company,
        showEditButton = _this$props13.showEditButton,
        totals = _this$props13.totals,
        csrfToken = _this$props13.csrfToken,
        statusChangeDate = _this$props13.statusChangeDate,
        consultantDueDate = _this$props13.consultantDueDate,
        hasQuickbooksCustomerId = _this$props13.hasQuickbooksCustomerId,
        reason = _this$props13.reason,
        updatedAt = _this$props13.updatedAt,
        quickbooksInvoiceUrl = _this$props13.quickbooksInvoiceUrl,
        editsRequestedBy = _this$props13.editsRequestedBy,
        editsRequestedOn = _this$props13.editsRequestedOn,
        approvedBy = _this$props13.approvedBy,
        approvedOn = _this$props13.approvedOn;
      var _this$state5 = this.state,
        submissionRequested = _this$state5.submissionRequested,
        projectedHours = _this$state5.projectedHours,
        status = _this$state5.status;
      if (isRep || isProjectTeamMember) {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions d-flex flex-row flex-wrap flex-lg-nowrap justify-content-md-end align-items-start gap-2"
        }, isRep && ['draft', 'submitted'].includes(status) && /*#__PURE__*/React.createElement(NotInvoicingModal, {
          invoiceId: id,
          consultantName: consultantName,
          notInvoicingUrl: "/invoices/not_invoicing",
          csrfToken: csrfToken,
          triggerType: "button",
          monthYear: "".concat(month, " ").concat(year),
          reason: status === 'not_invoicing' ? reason : '',
          redirectUrl: "/invoices/".concat(id),
          triggerText: "Mark as not Invoicing"
        }), (isProjectTeamMember || isRep) && status === 'draft' && /*#__PURE__*/React.createElement("div", {
          className: "actions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 normal-weight"
        }, !isRep && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "muted-gray-text"
        }, "Wait for the submission of this draft to approve the timesheet."), /*#__PURE__*/React.createElement("div", {
          className: "muted-gray-text"
        }, "Draft updated \xA0", dateDiffInDays(moment(updatedAt).toDate(), new Date()), "\xA0 days ago.")), !submissionRequested && isRep && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionDropdown, {
          id: "request-submit-timesheet-button",
          defaultLabel: "Request/Submit timesheet",
          links: [['component', this.renderRequestSubmission()], ['component', this.renderSubmitTimeSheet('link')]]
        })), !submissionRequested && isProjectTeamMember && /*#__PURE__*/React.createElement("div", null, this.renderRequestSubmission('button')))), status === 'submitted' && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
          className: "btn btn-secondary invoice-request-edit-redirect",
          href: "/invoices/".concat(id, "/edit"),
          style: {
            height: 'max-content'
          }
        }, "Request Edits"), /*#__PURE__*/React.createElement(ModalTrigger, {
          triggerText: "Approve",
          cancelButtonText: "No, Don't approve yet",
          idKey: "approve-invoice",
          buttonStyles: "primary",
          submitButtonNode: /*#__PURE__*/React.createElement("a", _extends({
            href: "/invoices/".concat(id, "/approve"),
            "data-turbo-method": "put",
            id: "approve-invoice-confirm",
            className: "btn btn-primary ".concat(isRep && !hasQuickbooksCustomerId ? 'disabled' : '')
          }, isRep && !hasQuickbooksCustomerId && {
            'aria-disabled': 'true'
          }), "Yes, Approve Invoice"),
          modalSize: "md"
        }, /*#__PURE__*/React.createElement("div", {
          className: "approve-invoice-modal style-guide"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-12"
        }, "Are you sure you want to approve this timesheet?"), isRep && !hasQuickbooksCustomerId && /*#__PURE__*/React.createElement("div", {
          className: "alert alert-danger mb-3"
        }, /*#__PURE__*/React.createElement("strong", null, "Warning:"), ' ', "This customer does not have a QuickBooks customer ID. Please add one before approving the invoice."), /*#__PURE__*/React.createElement("p", {
          className: "body-text-2 mb-15"
        }, "Once the timesheet is approved your company will assume the payment of the billed amount in a timely maner and as indicated in the contract.")))), status === 'edits_requested' && /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 muted-gray-text normal-weight"
        }, editsRequestedBy && editsRequestedOn ? /*#__PURE__*/React.createElement("div", null, "Edits requested by ".concat(editsRequestedBy, " on "), moment(editsRequestedOn).format('LL')) : /*#__PURE__*/React.createElement("div", null, " Edits requested on ".concat(moment(updatedAt).format('LL'))), /*#__PURE__*/React.createElement("div", null, consultantName, "\xA0 has until \xA0", moment(consultantDueDate).format('LL'), "\xA0 to submit their changes")), status === 'approved_by_rep' && isProjectTeamMember && /*#__PURE__*/React.createElement("div", {
          className: "pt-2 me-2 body-text-2 muted-gray-text normal-weight"
        }, approvedOn && approvedBy ? /*#__PURE__*/React.createElement(Fragment, null, "Approved by ".concat(approvedBy, "  - "), moment(approvedOn).format('LL'), "`") : /*#__PURE__*/React.createElement(Fragment, null, "Approved ".concat(statusChangeDate))), (status === 'paid' || status === 'approved_by_rep' && !(isRep || isAdmin)) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
          href: "/invoices/".concat(id, ".pdf"),
          className: "btn btn-secondary",
          target: "_blank",
          rel: "noreferrer",
          style: {
            height: 'max-content'
          }
        }, "PDF"), /*#__PURE__*/React.createElement("a", {
          href: "/invoices/".concat(id, ".csv"),
          className: "btn",
          target: "_blank",
          rel: "noreferrer",
          style: {
            height: 'max-content'
          }
        }, "CSV")), isRep && status === 'not_invoicing' && /*#__PURE__*/React.createElement("button", {
          id: "btn-revert-to-draft",
          className: "btn btn-secondary",
          onClick: this.handleRevertToDraft
        }, "Return to Draft"), (isRep || isAdmin) && (status === 'approved_by_rep' || status === 'not_invoicing') && /*#__PURE__*/React.createElement(ActionDropdown, {
          id: "approved-by-rep-actions",
          defaultLabel: isRep && !quickbooksInvoiceUrl && status === 'approved_by_rep' ? this.renderPushToQuickbooks() : /*#__PURE__*/React.createElement("a", {
            href: "/invoices/".concat(id, ".pdf"),
            className: "btn btn-primary"
          }, "PDF"),
          indicatorIcon: chevronDown,
          links: [['link', 'Download PDF', "/invoices/".concat(id, ".pdf"), '_blank'], ['link', 'Download CSV', "/invoices/".concat(id, ".csv"), '_blank'], ['separator'], ['node', this.renderRetractButton()], ['node', this.renderOverridesModal()]]
        }));
      }

      // consultant actions
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "actions d-flex flex-row flex-wrap gap-2"
      }, status === 'draft' && totals.total === 0 && /*#__PURE__*/React.createElement(NotInvoicingModal, {
        invoiceId: id,
        consultantName: consultantName,
        notInvoicingUrl: "/invoices/not_invoicing",
        csrfToken: csrfToken,
        triggerType: "button",
        reason: reason,
        monthYear: "".concat(month, " ").concat(year),
        redirectUrl: "/invoices/".concat(id),
        isConsultant: true
      }), status === 'not_invoicing' && showEditButton && /*#__PURE__*/React.createElement("div", {
        className: "change-to-draft body-text-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-8"
      }, "Do you need to add hours for ".concat(month, " ").concat(year)), /*#__PURE__*/React.createElement("a", {
        href: "/invoices/".concat(id, "/draft"),
        "data-turbo-method": "put"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-3"
      }), "Create ".concat(month, " Timesheet")))), status === 'submitted' && /*#__PURE__*/React.createElement("div", {
        className: "submitted-info"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-info-circle me-3"
      }), /*#__PURE__*/React.createElement("span", {
        className: "submitted-notice medium-weight"
      }, "".concat(company, " is reviewing your timesheet submitted ").concat(statusChangeDate, "."))), (status === 'approved_by_rep' || status === 'paid') && /*#__PURE__*/React.createElement("div", {
        className: "dropdown"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary dropdown-toggle fs-hide",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, "Export"), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "/invoices/".concat(id, ".pdf"),
        rel: "noreferrer",
        className: "mx-3"
      }, " PDF")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "/invoices/".concat(id, ".csv"),
        rel: "noreferrer",
        className: "mx-3"
      }, " CSV")))), showEditButton && (status === 'draft' || status === 'edits_requested') && /*#__PURE__*/React.createElement("a", {
        href: "/invoices/".concat(id, "/edit"),
        className: "btn btn-secondary edit-invoice-on-show"
      }, "Edit"), (status === 'draft' || status === 'edits_requested') && (projectedHours ? /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Submit Timesheet",
        cancelButtonText: "No, Don't submit yet",
        idKey: "submit-invoice",
        buttonStyles: "primary",
        submitButtonNode: /*#__PURE__*/React.createElement("a", {
          href: "/invoices/".concat(id, "/submit_to_clora"),
          "data-turbo-method": "put",
          id: "submit-invoice",
          className: "btn btn-primary",
          role: "button"
        }, "Yes, Submit to employer"),
        closeAfterSubmit: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "approve-invoice-modal style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Do you want to submit your \xA0", month, "\xA0", year, "\xA0 timesheet to \xA0", company, "?"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-4"
      }, "You cannot modify your timesheet after submitting it to the employer."))) : /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this7.errorMsg(true);
        },
        role: "button",
        tabIndex: 0
      }, "Submit Timesheet"))), status !== 'not_invoicing' && /*#__PURE__*/React.createElement("div", {
        className: "mt-3 body-text-2 invoice-state"
      }, status !== 'submitted' && this.renderInvoiceState()));
    }
  }, {
    key: "renderMemo",
    value: function renderMemo() {
      var _this8 = this;
      var _this$props14 = this.props,
        isRep = _this$props14.isRep,
        isProjectTeamMember = _this$props14.isProjectTeamMember,
        showEditButton = _this$props14.showEditButton,
        consultantName = _this$props14.consultantName;
      var _this$state6 = this.state,
        status = _this$state6.status,
        memo = _this$state6.memo,
        isReadingMore = _this$state6.isReadingMore,
        showReadMore = _this$state6.showReadMore;
      if (!isRep && !isProjectTeamMember && !showEditButton && (status === 'draft' || status === 'edits_requested')) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-4 body-text-2 invoice-memo"
        }, /*#__PURE__*/React.createElement("div", {
          className: "demibold mb-2"
        }, "Add notes and/or instructions about your timesheet:"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextareaAutosize, {
          name: "memo",
          className: "memo",
          placeholder: "Type your comments",
          value: memo || '',
          onChange: function onChange(e) {
            return _this8.updateMemo(e.target.value);
          },
          rows: 2
        })));
      }
      if (memo) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-4 body-text-2 invoice-memo display-memo"
        }, /*#__PURE__*/React.createElement("div", {
          className: "demibold"
        }, isRep || isProjectTeamMember ? "".concat(consultantName, "'s notes on this timesheet") : 'Your notes on this timesheet'), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 memo-text ".concat(isReadingMore ? 'show' : 'overflow'),
          ref: function ref(el) {
            _this8.memoElement = el;
          }
        }, memo), showReadMore && /*#__PURE__*/React.createElement("div", {
          className: "align"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-text-2",
          tabIndex: 0,
          role: "link",
          onClick: this.readMore
        }, isReadingMore ? 'Read Less' : 'Read More')));
      }
      return null;
    }
  }, {
    key: "renderProjectedHours",
    value: function renderProjectedHours() {
      var _this9 = this;
      var _this$props15 = this.props,
        isRep = _this$props15.isRep,
        isProjectTeamMember = _this$props15.isProjectTeamMember,
        showEditButton = _this$props15.showEditButton;
      var _this$state7 = this.state,
        status = _this$state7.status,
        projectedHours = _this$state7.projectedHours,
        showErrorMsg = _this$state7.showErrorMsg;

      // ability to edit
      if (!isProjectTeamMember && !showEditButton && (status === 'draft' || status === 'edits_requested')) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-4 body-text-2 invoice-projected-hours"
        }, /*#__PURE__*/React.createElement("div", {
          className: "demibold mb-2"
        }, "How many hours do you expect to work/bill next month?", /*#__PURE__*/React.createElement(InfoTooltip, {
          triggerClassName: "optional-id-tooltip-trigger",
          tooltipId: "optional-id-tooltip",
          tooltipPlacement: "top",
          tooltipText: "Please enter your best guess, even if you don't have the exact hours. We use this data as an input in forecasting process and to further improve your future experience."
        }), /*#__PURE__*/React.createElement("span", {
          className: "required-text ".concat(!showErrorMsg ? 'invoice' : 'invoice error')
        }, "* Required")), /*#__PURE__*/React.createElement("div", {
          className: "projected-hours-container"
        }, /*#__PURE__*/React.createElement("input", {
          className: "projected-hours-container ".concat(!showErrorMsg ? 'input' : 'input error'),
          placeholder: "",
          type: "number",
          id: "projectedHours",
          name: "projectedHours",
          value: projectedHours !== null ? projectedHours : '',
          onKeyDown: numericKeyFilter,
          onChange: function onChange(e) {
            return _this9.updateProjectedHours(e.target.value);
          },
          required: true
        }), /*#__PURE__*/React.createElement("span", {
          className: "ms-2"
        }, "hours")), showErrorMsg && /*#__PURE__*/React.createElement("p", {
          className: "invoice-error-text"
        }, " Please enter projected hours for next month to submit your timesheet"));
      }
      if (!isProjectTeamMember && (!showEditButton || isRep) && projectedHours !== null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-4 body-text-2 display-proposed-hours"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-2 demibold"
        }, "Expected hours to work/bill next month"), /*#__PURE__*/React.createElement("div", null, "".concat(projectedHours, " hours")));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props16 = this.props,
        invoiceNumber = _this$props16.invoiceNumber,
        abbreviatedMonth = _this$props16.abbreviatedMonth,
        year = _this$props16.year,
        projectName = _this$props16.projectName,
        consultantName = _this$props16.consultantName,
        totals = _this$props16.totals,
        company = _this$props16.company,
        feedback = _this$props16.feedback,
        updated = _this$props16.updated,
        isRep = _this$props16.isRep,
        isProjectTeamMember = _this$props16.isProjectTeamMember,
        hourLimit = _this$props16.hourLimit,
        quickbooksInvoiceUrl = _this$props16.quickbooksInvoiceUrl,
        children = _this$props16.children,
        workCommitment = _this$props16.workCommitment,
        areaOfExpertises = _this$props16.areaOfExpertises,
        tags = _this$props16.tags,
        jobTitles = _this$props16.jobTitles,
        description = _this$props16.description,
        responsibilities = _this$props16.responsibilities,
        duration = _this$props16.duration,
        workLocation = _this$props16.workLocation,
        shortOfficeLocation = _this$props16.shortOfficeLocation,
        startDate = _this$props16.startDate,
        location = _this$props16.location;
      var _this$state8 = this.state,
        status = _this$state8.status,
        statusDisplay = _this$state8.statusDisplay;
      var badgeCss = isProjectTeamMember ? "".concat(status, " employer") : status;
      return /*#__PURE__*/React.createElement("div", {
        className: "invoice-header card p-5 border-0 mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "information d-flex flex-column flex-md-row justify-content-between"
      }, /*#__PURE__*/React.createElement("div", {
        className: "general-info"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3 invoice-date-header d-flex flex-column flex-md-row flex-wrap gap-2"
      }, abbreviatedMonth, ' ', year, ' ', /*#__PURE__*/React.createElement("span", {
        className: "badge body-text-3 ".concat(badgeCss, " d-none d-md-block")
      }, statusDisplay), updated && /*#__PURE__*/React.createElement("span", {
        className: "demibold ms-3 updated-banner"
      }, "All changes saved!"), /*#__PURE__*/React.createElement("div", {
        className: "mobile-view-block body-text-2 normal-weight"
      }, "Invoice #", /*#__PURE__*/React.createElement("span", {
        className: "invoice-number"
      }, invoiceNumber), /*#__PURE__*/React.createElement("span", {
        className: "badge body-text-3 ".concat(badgeCss, " mobile-view-block")
      }, statusDisplay), isRep && quickbooksInvoiceUrl && /*#__PURE__*/React.createElement("span", null, "\xA0\u2010", /*#__PURE__*/React.createElement("a", {
        href: quickbooksInvoiceUrl,
        target: "_blank",
        rel: "noreferrer"
      }, "Quickbooks Invoice"))), this.renderDueDate()), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight d-none d-md-block"
      }, invoiceNumber && /*#__PURE__*/React.createElement(Fragment, null, "Invoice #", /*#__PURE__*/React.createElement("span", {
        className: "invoice-number"
      }, invoiceNumber)), isRep && quickbooksInvoiceUrl && /*#__PURE__*/React.createElement("span", null, "\xA0\u2010", /*#__PURE__*/React.createElement("a", {
        href: quickbooksInvoiceUrl,
        target: "_blank",
        rel: "noreferrer"
      }, "Quickbooks Invoice")))), this.renderActions()), this.renderAmountOverrideWarning(), (status === 'draft' || isRep) && hourLimit !== null && /*#__PURE__*/React.createElement("div", {
        className: "mt-4 body-text-2"
      }, this.renderHourLimitWarning()), /*#__PURE__*/React.createElement("div", {
        className: "summary d-flex flex-column flex-lg-row justify-content-between gap-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "company-and-project body-text-2"
      }, (isProjectTeamMember || isRep) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "invoice-to demibold"
      }, "Consultant"), /*#__PURE__*/React.createElement("div", {
        className: "consultant-name"
      }, consultantName)), !isProjectTeamMember && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "invoice-to demibold"
      }, "Company"), /*#__PURE__*/React.createElement("div", {
        className: "company-name"
      }, company)), /*#__PURE__*/React.createElement("div", {
        className: "project demibold"
      }, "Project"), /*#__PURE__*/React.createElement(ProjectNameSummaryModal, {
        projectName: projectName,
        workCommitment: workCommitment,
        areaOfExpertises: areaOfExpertises,
        tags: tags,
        jobTitles: jobTitles,
        description: description,
        responsibilities: responsibilities,
        duration: duration,
        workLocation: workLocation,
        shortOfficeLocation: shortOfficeLocation,
        startDate: startDate,
        location: location,
        buttonStyles: "body-text-1"
      })), /*#__PURE__*/React.createElement("div", {
        className: "total-invoice body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "total-pay-header medium-weight justify-content-between"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Total Invoice")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, formatCurrency(totals.total))), totals.adjustedTotal && totals.adjustedTotal !== '$0.00' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "(Billing ".concat(totals.adjustedTotal, ")"))) : null), /*#__PURE__*/React.createElement("div", {
        className: "consulting justify-content-between"
      }, /*#__PURE__*/React.createElement("div", null, "Consulting"), /*#__PURE__*/React.createElement("div", null, formatCurrency(totals.consulting)), totals.adjustedConsulting && totals.adjustedConsulting !== '$0.00' ? /*#__PURE__*/React.createElement("div", null, "(Billing ".concat(totals.adjustedConsulting, ")")) : null), /*#__PURE__*/React.createElement("div", {
        className: "travel justify-content-between"
      }, /*#__PURE__*/React.createElement("div", null, "Travel"), /*#__PURE__*/React.createElement("div", null, formatCurrency(totals.travel)), totals.adjustedTravel && totals.adjustedTravel !== '$0.00' ? /*#__PURE__*/React.createElement("div", null, "(Billing ".concat(totals.adjustedTravel, ")")) : null), /*#__PURE__*/React.createElement("div", {
        className: "expenses justify-content-between"
      }, /*#__PURE__*/React.createElement("div", null, "Expenses"), /*#__PURE__*/React.createElement("div", null, formatCurrency(totals.expense))))), this.renderProjectedHours(), this.renderMemo(), feedback && (status === 'edits_requested' || isRep && status === 'submitted') && /*#__PURE__*/React.createElement("div", {
        className: "invoice-feedback body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "medium-weight mb-6"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }), "Requested general edits:"), /*#__PURE__*/React.createElement("div", null, feedback))), children);
    }
  }]);
}(Component);
InvoiceHeader.propTypes = {
  invoiceNumber: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  abbreviatedMonth: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  statusDisplay: PropTypes.string,
  projectName: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  consultantDueDate: PropTypes.string,
  employerApprovalDueDate: PropTypes.string,
  memo: PropTypes.string,
  totals: PropTypes.shape({}).isRequired,
  totalHours: PropTypes.number,
  totalMinutes: PropTypes.number,
  hourLimit: PropTypes.number,
  company: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  showEditButton: PropTypes.bool,
  statusChangeDate: PropTypes.string,
  isRep: PropTypes.bool,
  isAdmin: PropTypes.bool,
  feedback: PropTypes.string,
  updated: PropTypes.bool,
  hasQuickbooksCustomerId: PropTypes.bool,
  editCompanyUrl: PropTypes.string,
  quickbooksInvoiceUrl: PropTypes.string,
  reason: PropTypes.string,
  children: PropTypes.node,
  isProjectTeamMember: PropTypes.bool,
  updatedAt: PropTypes.instanceOf(Date),
  editsRequestedBy: PropTypes.string,
  editsRequestedOn: PropTypes.instanceOf(Date),
  approvedBy: PropTypes.string,
  approvedOn: PropTypes.instanceOf(Date),
  workCommitment: PropTypes.number.isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  showHourWarning: PropTypes.bool,
  projectedHours: PropTypes.number,
  grossRevenueOverride: PropTypes.string,
  consultantPayoutOverride: PropTypes.string,
  overrideReason: PropTypes.string,
  overrideDate: PropTypes.string
};
InvoiceHeader.defaultProps = {
  memo: null,
  totalHours: 0,
  totalMinutes: 0,
  hourLimit: null,
  showEditButton: false,
  isRep: false,
  isProjectTeamMember: false,
  isAdmin: false,
  feedback: null,
  updated: false,
  editCompanyUrl: null,
  hasQuickbooksCustomerId: false,
  quickbooksInvoiceUrl: null,
  reason: null,
  statusDisplay: null,
  consultantDueDate: null,
  employerApprovalDueDate: null,
  company: null,
  statusChangeDate: null,
  children: null,
  updatedAt: null,
  editsRequestedBy: null,
  editsRequestedOn: null,
  approvedBy: null,
  approvedOn: null,
  areaOfExpertises: [],
  tags: [],
  jobTitles: '',
  startDate: null,
  showHourWarning: false,
  projectedHours: null,
  overrideDate: null,
  grossRevenueOverride: null,
  consultantPayoutOverride: null,
  overrideReason: null
};
export default InvoiceHeader;